<template>
  <section class="d-flex justify-content-center align-items-center">
    <div class="circle-border d-flex justify-content-center align-items-center">
      <p class="mb-0">{{ loaded }}%</p>
    </div>
  </section>
</template>

<script>
export default {
  props: ["loaded"]
};
</script>

<style scoped>
section {
  background-color: #c83402;
  height: 100vh;
	position: absolute;
	width:100vw;
	top:0;
	z-index:999;
}
.circle-border {
  width: 100px;
  height: 100px;
  border: 2px solid #ffa176;
  background-color: rgba(141, 20, 14, 0.5);
  border-radius: 50%;
}
p {
  color: #ffa176;
	font-weight: bold;
	transform: rotate(-180deg);
}
</style>
